import {Component} from '@angular/core';
import {NlrHasPermissionsPipe} from '../../common/pipe/nlr-has-permissions.pipe';
import {NlrPermissionsDisabledPipe} from '../../common/pipe/nlr-permissions-disabled-pipe';
import {PlanModelService} from '../../common/service/plan-model.service';
import {PermissionsService} from '../../common/service/permissions.service';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';

@Component({
    selector: 'general-comments',
    imports: [NlrHasPermissionsPipe, NlrPermissionsDisabledPipe, FormsModule],
    templateUrl: './general-comments.component.html',
    styleUrl: './general-comments.component.scss',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class GeneralCommentsComponent {
    title = 'General comments';

    permissions = ['EDIT_LODGE', 'VIEW_LODGE'];

    constructor(
        private planModelService: PlanModelService,
        private permissionsService: PermissionsService
    ) {}

    getModel() {
        return this.planModelService.getModel();
    }

    isDisabled() {
        return this.planModelService.readonly || !this.permissionsService.hasEditPermission(this.permissions);
    }
}
